module.exports = __webpack_public_path__ + "static/mrHugoPodcast-668564c0d0416f17192fcdf00a981bd7.jpg";